<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    
    .dobspan {
        margin-left: 20px
    }

    span.description {
        display: block;
    }

    div.busy_spinner {
        position: absolute;
        z-index: 1000;
        top: 10px;
        right: 30px;
        width: 20px;
        height: 20px;
    }
</style>
<template>
    <div style="position:relative">
        <selectize v-model="selection"
                   :load="loadResults"
                   :focus="focus"
                   labelField="firstName"
                   valueField="id"
                   :searchField=searchFields
                   :render="render"
                   maxOptions="25"
                   openOnFocus="true"
                   :clear-selection="clearResult"
                   placeholder="Quick search patient (2+ Characters)" />
        <transition name="fade">
            <div class="busy_spinner" v-if="isLoading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </transition>
        
    </div>
</template>
<script>
    import selectize from '../../corecontrols/selectize/selectize.scp.html'
    import FmdDal from '../../../scripts/FmdDal'
    import Formatter from '../../corecontrols/formatters/Formatter'

    export default {
        props: ['value', 'focus', 'clearResult'],
        components: {
            selectize,

        },
        watch: {
            selection() {
                console.log(this.selection);
                if (this.selection) {
                    this.$emit('input', this.selection);

                }
                //this.selection = null;
            }
        },
        mounted() {
            this.FmdDal = new FmdDal(this.$root.CurrentUnitId);
        },
        data: function () {
            return {

                selection: {},
                isLoading: false,
                FmdDal: {},
                searchFields: ['firstName', 'lastName', 'dob'],
                render: {
                    item: function (item, escape) {
                        return '<div>' + escape(item.firstName + " " + item.lastName) + '<small style="margin-left:10px">' + Formatter.FormatDate(item.dob) + '</small></div>'
                    },
                    option: function (item, escape) {
                        return '<div>' +
                            '<strong style="margin-right:10px">' + " <small class='text-primary'>(" + escape(item.title) + ")</small> " + escape(item.firstName + " " + item.lastName) + '</strong>' +
                            '<small class="text-info">' + escape(Formatter.FormatDate(item.dob)) + '</small>' +
                            //'<small class="text-muted"  style="display:block"><em>' + escape((item.postCode ? ", " + item.postCode : "")) + '</em></small>' +
                            '</div>';
                    }
                }
            }
        },
        methods: {
            loadResults: function (query, callback) {

                if (!this.FmdDal || !query.length) return callback();

                //if (query.length <= 2)
                //    return callback();

                this.isLoading = true;
                var that = this;
                this.FmdDal.SearchPatients(query).then(data => {
                    console.log("Search data : ", data);
                    callback(data);
                    this.isLoading = false;
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PatientSearchBox.scp.html?550900d3